/* tslint:disable */
/* eslint-disable */

export enum Authority {
  ADMIN = 'ROLE_ADMIN',
  ORGANIZATION_USER = 'ROLE_ORGANIZATION_USER',
  RETAIL_USER = 'ROLE_RETAIL_USER',
  SALES = 'ROLE_SALES',
  AUTHOR = 'ROLE_AUTHOR',
  MANAGER = 'ROLE_MANAGER'
}
